export { default as PayWaiterConfirmation } from "./PayWaiterConfirmation";
export type { IPayWaiterConfirmationProps } from "./types";
